import type { WorkspaceDialogService } from '@affine/core/modules/dialogs';

/** More storage comes with a bigger plan, never with seats. */
export function openStoragePlans(
  workspaceDialogService: WorkspaceDialogService
) {
  workspaceDialogService.open('setting', {
    activeTab: 'workspace:plans',
    scrollAnchor: 'cloudPricingPlan',
  });
}
